/* eslint-disable react/display-name */
import React, { useEffect, useRef, useState } from 'react'
import { Modal, notification, Row } from 'antd'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import type { ColDef } from 'ag-grid-community'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { TreatmentBillingCategories, BillingCategoryName } from '../../../models/billingCategory'
import { getMemberPointParticipatoryList, submitMemberPoint } from '../MembersManagementPageSlice'
import { RootDispatch } from '../../../app/store'

interface AddTreatmentCategoryForPointsProps {
  visible: boolean
  onCancel: () => void
  onSuccess?: () => void
  isExchange?: number
}

export const AddTreatmentCategoryForPoints = ({ visible, onCancel, onSuccess, isExchange = 1 }: AddTreatmentCategoryForPointsProps) => {
  const dispatch = useDispatch<RootDispatch>()
  const [loading, setLoading] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [data, setData] = useState<any[]>(() =>
    TreatmentBillingCategories.map((v) => ({ billingCategory: v }))
  )

  const loadData = () => {
    setLoading(true)
    dispatch(getMemberPointParticipatoryList({ type: 1, size: 10000, invoiceType: true, catalogType: 1 }))
      .then(unwrapResult)
      .then((res: any) => {
        const records: any[] = res?.records || res || []
        const savedSet = new Set(records.map((r: any) => r.billingCategory))

        if (isExceptionSavedRef.current) {
          // 已保存过分类，只展示首次打开时的那几种
          setData(initialCategoriesRef.current.map((v) => ({ billingCategory: v })))
        } else {
          // 只展示未保存过的分类
          const filtered = TreatmentBillingCategories.filter((v) => !savedSet.has(v))
          initialCategoriesRef.current = filtered
          setData(filtered.map((v) => ({ billingCategory: v })))
        }
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (visible) {
      isExceptionSavedRef.current = false
      initialCategoriesRef.current = []
      loadData()
    }
  }, [visible])

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [selectedRows, setSelectedRows] = useState<any[]>([])
  const isExceptionSavedRef = useRef(false)
  const initialCategoriesRef = useRef<string[]>([])

  const handleSelectionChange = (rows: any[], _nodes: any[], ids: any[]) => {
    setSelectedRowKeys(ids)
    setSelectedRows(rows.filter(Boolean))
  }

  const handleCellClicked = (event: any) => {
    const colField = event?.colDef?.field
    if (colField === 'checkbox') return
    event.node.setSelected(!event.node.selected)
  }

  const handleOk = async () => {
    if (selectedRows.length === 0) {
      notification.warning({ message: '请至少选择一项' })
      return
    }
    const list = selectedRows.filter(Boolean).map((r: any) => ({
      billingCategory: r.billingCategory,
      isExchange,
      catalogType: 1,
      name: BillingCategoryName(r.billingCategory),
    }))
    setConfirmLoading(true)
    try {
      try {
        await dispatch(submitMemberPoint(list)).then(unwrapResult)
      } catch (e) {
        return
      }
      notification.success({ message: '保存成功' })
      onSuccess?.()
      handleCancel()
    } finally {
      setConfirmLoading(false)
    }
  }

  const handleCancel = () => {
    setSelectedRowKeys([])
    setSelectedRows([])
    onCancel()
  }

  const columns: ColDef[] = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      width: 50,
      minWidth: 50,
      maxWidth: 50,
      pinned: 'left',
      lockPosition: 'left',
      suppressMovable: true,
      resizable: false,
      sortable: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      flex: 1,
      sortable: false,
      cellStyle: { textAlign: 'center' },
      cellRendererFramework: (params: any) => BillingCategoryName(params.value),
    },
  ]

  return (
    <Modal
      title="添加诊疗分类"
      visible={visible}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={confirmLoading}
      width={600}
      destroyOnClose
    >
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <span>选择开票项目</span>
        <span>已选择 {selectedRowKeys.length} 项</span>
      </Row>
      <div style={{ height: 500 }}>
        <SimpleAgGrid
          rowHeight={41}
          isLoading={loading}
          rowSelection="multiple"
          suppressRowClickSelection={true}
          selectedRowKeys={selectedRowKeys}
          getRowId={(r: any) => r.billingCategory}
          column={columns}
          dataSource={data}
          pagination={false}
          onSelectionChange={handleSelectionChange}
          onCellClicked={handleCellClicked}
        />
      </div>
    </Modal>
  )
}
